import { getElements, ifSelectorExist } from "./utils";

export default function flipCardsMobile() {
  const cards = getElements(".coaches__card");
  const container = document.querySelector(".coaches__profiles");
  const showMoreBtn = document.createElement("button");

  if (ifSelectorExist(container)) {
    if (window.innerWidth <= 767) {
      if (ifSelectorExist(cards)) {
        
        if (cards.length > 4) {
          cards.forEach((card, index) => {
            if (index > 2) {
              card.style.display = "none";
            }

            if (index == 2) {
              card.id = "lastItem";
            }

            
          });

          showMoreBtn.textContent = "See More";
          showMoreBtn.classList.add("btn");
          container.insertAdjacentElement("afterend", showMoreBtn);

          showMoreBtn.addEventListener("click", () => {
            const isSeeMore = showMoreBtn.textContent === "See More";

            if (isSeeMore) {
              cards.forEach((card, index) => {
                if (index > 2) {
                  card.style.display = "block";
                }
              });
              showMoreBtn.textContent = "See Less";
            } else {
              cards.forEach((card, index) => {
                if (index > 2) {
                  card.style.display = "none";
                }
              });
              showMoreBtn.textContent = "See More";
              document.getElementById('lastItem').scrollIntoView();
            }
          });
        }

        cards.forEach((card, index) => {
          const currentCard = cards[index];
          currentCard.addEventListener("click", () => {
            if (currentCard.classList.contains("flip")) {
              currentCard.classList.remove("flip");
            } else {
              cards.forEach((card) => card.classList.remove("flip"));
              currentCard.classList.add("flip");
            }
          });
        });
      }
    }
  }
}
